import script from "./TargetChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./TargetChart.vue?vue&type=script&setup=true&lang=ts"

import "./TargetChart.vue?vue&type=style&index=0&id=aba6d17c&scoped=true&lang=stylus"
script.__scopeId = "data-v-aba6d17c"

export default script